// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBox-cls1_zn9","cls2":"SearchBox-cls2_TMw SearchBox-cls1_zn9"};